<div class="client-dashboard" :class="{ 'sidebar-hidden': hide_sidebar }">
  <div class="dashboard-wrapper">
    <!-- Sidebar -->
    <div v-if="!hide_sidebar" class="sidebar-section">
       <Sidebar />
    </div>

    <!-- Main Content Area -->
    <div class="main-content-section">
      <NavBar @toggle-sidebar="toggle_sidebar" />
      <router-view :key="$route.fullPath"></router-view>
      <AppFooter />
    </div>
  </div>
</div>